import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import '../src/assets/css/fontawesome-all.min.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'swiper/css';
import 'swiper/css/effect-fade';

import VueGtag from 'vue-gtag';

const app = createApp(App);

app.use(VueGtag, {
    config: { id: 'G-8HKTB7LXYN' }
  }, router);

app.use(router);

app.mount('#app');

